import { apiService } from './api';

export interface LegalDocument {
  type: string;
  version: string;
  url: string;
  title: string;
  accepted: boolean;
  acceptedAt?: string;
}

export interface LegalStatusResponse {
  documents: LegalDocument[];
}

export interface LegalAcceptResponse {
  accessToken: string;
  refreshToken: string;
}

export const legalService = {
  async getStatus(): Promise<LegalStatusResponse> {
    return await apiService.get('/v1/legal/status');
  },

  async acceptDocuments(documentTypes: string[]): Promise<LegalAcceptResponse> {
    return await apiService.post('/v1/legal/accept', { documents: documentTypes });
  },
};
